import styled from 'styled-components';
import React from 'react';
import Tag from '../Tag';
import FontIcon from '../FontIcon';

interface ArticleCardFooterProps {
  tags?: string[];
  hasVideo?: boolean;
  className?: string;
}

function ArticleCardFooter({
  tags = [],
  hasVideo,
  className,
}: ArticleCardFooterProps) {
  return (
    <ArticleCardFooterCss className={className}>
      {tags.map((tag, idx) => (
        <Tag key={`tag-${idx}`} size="small" text={tag} />
      ))}
      {hasVideo && <ArticleVideoIconCss name="player_stream_icon" />}
    </ArticleCardFooterCss>
  );
}

const ArticleCardFooterCss = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;

  & > div,
  & > span {
    margin-bottom: ${p => p.theme.sizes.spacing1};
    margin-right: ${p => p.theme.sizes.spacing1};
  }
`;

const ArticleVideoIconCss = styled(FontIcon)`
  font-size: ${p => p.theme.typography.textBase2};
  color: ${p => p.theme.colors.primary500};
  &:not(:last-child) {
    margin-right: ${p => p.theme.sizes.spacing1};
  }
`;

export default ArticleCardFooter;
